<template>
  <div class="v_all_all">
    <div class="v_all_background" v-if="haveData == 1">
      <!--
      <el-input v-model="b"></el-input>
      <el-input v-model="c"></el-input>
      <el-input v-model="d"></el-input>
      <el-input v-model="e"></el-input> -->
      <div class="v_top_line"></div>

      <div class="v_top_person">
        <div class="v_top_person_title">
          <div class="v_top_person_title_left">用户信息</div>
          <div
            class="v_top_person_title_right"
            @click="downCreateOR()"
            v-if="pms.downCode"
          >
            下载新建纪念堂二维码
          </div>
        </div>
        <div class="v_line"></div>
        <div class="v_top_person_name">
          <span class="v_top_person_nick">昵称：</span>{{ nickName }}
        </div>
        <div class="v_line_small"></div>
        <div class="v_top_person_name" style="position: relative;">
          <div style="float: left;"><span class="v_top_person_nick">用户ID：</span>{{ idForShow }}</div>
          <div style="float: none; text-align: center;"><span class="v_top_person_nick">App登录：</span>{{ loginMobileState }}</div>
        </div>
        <div class="v_line_small"></div>
        <div class="v_top_person_remark">备注标签：</div>
        <div
          class="v_top_person_remark_list"
          v-if="serviceAdminRemark.length != 0"
        >
          <div
            v-for="(item, i) in serviceAdminRemark"
            :key="i"
            class="v_remark_item"
          >
            {{ item.nick }}：{{ item.remark }}
          </div>
        </div>
        <div class="v_have_no_text_no" v-if="serviceAdminRemark.length == 0">
          当前暂无备注
        </div>
        <div class="v_top_person_bottom">
          <div class="v_top_person_button" @click="toRemark">备注</div>
        </div>
      </div>

      <div class="v_memorial_all">
        <div class="v_memorial_title">
          Ta管理的纪念堂<span class="v_memorial_number"
            >（合计: {{ dmList.length }}）</span
          >
        </div>
        <div class="v_line"></div>
        <div v-if="dmList.length == 0" class="v_have_no">
          <img
            src="@/assets/images/personal/iv_have_no.png"
            alt=""
            class="iv_have_no"
          />
          <div class="v_have_no_text">当前暂无纪念堂</div>
        </div>
        <div v-for="(item, i) in dmList" :key="i" class="v_memorial_item">
          <div class="v_memorial_item_title">
            <div class="v_memorial_item_left">纪念堂名称：</div>
            <div
              class="v_memorial_item_name"
              style="color: #f19100"
              @click="showDeadInfoDialog(dmList, i)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="v_memorial_item_title">
            纪念堂编号：<span class="v_memorial_item_name">{{
              item.codeNew
            }}</span
            ><span class="v_copy" @click="copy(item.code)">复制</span>
          </div>
          <div class="v_memorial_item_title">
            创建日期：<span class="v_memorial_item_name">{{
              item.createTimeNew
            }}</span>
          </div>
          <div class="v_memorial_item_title" @click="addCloseTime(item.id)">
            有效期至：<span
              class="v_memorial_item_name"
              v-if="item.foreverState == 0"
              >{{ item.closeTimeNew }}</span
            ><span class="v_memorial_item_name" v-if="item.foreverState == 1"
              >永久</span
            >
          </div>
          <div class="v_memorial_item_title">
            纪念堂状态：<span class="v_memorial_item_name">{{
              item.stateNew
            }}</span
            ><span
              class="v_memorial_item_name_red"
              v-if="item.spaceFrozen == 1"
              >{{ item.stateCold }}</span
            >
          </div>
          <div class="v_memorial_item_title">
            纪念堂是否连续包年：<span class="v_memorial_item_name">{{
              item.autoRenewStateName
            }}</span>
          </div>
          <div class="v_memorial_item_title">
            <div class="v_memorial_item_left">经手：</div>
            <div class="v_memorial_item_name">
              {{ item.unitShortNames }}
            </div>
          </div>
          <div class="v_memorial_item_title">
            Ta是此纪念堂的：<span class="v_memorial_item_name">{{
              item.userStateName
            }}</span>
          </div>
          <div class="v_memorial_item_title">
            Ta访问此纪念堂的次数：<span class="v_memorial_item_name">{{
              item.userViewCount
            }}</span>
          </div>

          <div class="v_memorial_bottom">
            <div class="v_update_button" @click="updateAll(item)">
              资料上传记录
            </div>
            <!--  -->
            <div
              class="v_create_button"
              @click="createdRenew(item.code, item.name)"
              v-if="item.showRenewalAdmin == 1 && pms.renewCode"
            >
              创建续费二维码
            </div>
            <div
              class="v_create_button_no"
              v-if="item.showRenewalAdmin == 0 && pms.renewCode"
            >
              创建续费二维码
            </div>
          </div>
        </div>
        <div class="v_memorial_bottom_line"></div>
      </div>

      <div class="v_memorial_all">
        <div class="v_memorial_title">
          Ta拜访过的纪念堂<span class="v_memorial_number"
            >（合计: {{ visitDmList.length }}）</span
          >
        </div>
        <div class="v_line"></div>
        <div v-if="visitDmList.length == 0" class="v_have_no">
          <img
            src="@/assets/images/personal/iv_have_no.png"
            alt=""
            class="iv_have_no"
          />
          <div class="v_have_no_text">当前暂无纪念堂</div>
          <div class="v_memorial_bottom_line"></div>
        </div>
        <div v-for="(item, i) in visitDmList" :key="i" class="v_memorial_item">
          <div class="v_memorial_item_title">
            <div class="v_memorial_item_left">纪念堂名称：</div>
            <div
              class="v_memorial_item_name"
              style="color: #f19100"
              @click="showDeadInfoDialog(visitDmList, i)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="v_memorial_item_title">
            纪念堂编号：<span class="v_memorial_item_name">{{
              item.codeNew
            }}</span
            ><span class="v_copy" @click="copy(item.code)">复制</span>
          </div>
          <div class="v_memorial_item_title">
            创建日期：<span class="v_memorial_item_name">{{
              item.createTimeNew
            }}</span>
          </div>
          <div class="v_memorial_item_title">
            有效期至：<span
              class="v_memorial_item_name"
              v-if="item.foreverState == 0"
              >{{ item.closeTimeNew }}</span
            ><span class="v_memorial_item_name" v-if="item.foreverState == 1"
              >永久</span
            >
          </div>
          <div class="v_memorial_item_title">
            纪念堂状态：<span class="v_memorial_item_name">{{
              item.stateNew
            }}</span
            ><span
              class="v_memorial_item_name_red"
              v-if="item.spaceFrozen == 1"
              >{{ item.stateCold }}</span
            >
          </div>
          <div class="v_memorial_item_title">
            <div class="v_memorial_item_left">经手：</div>
            <div class="v_memorial_item_name">
              {{ item.unitShortNames }}
            </div>
          </div>
          <div class="v_memorial_item_title">
            Ta是此纪念堂的：<span class="v_memorial_item_name">访客</span>
          </div>
          <div class="v_memorial_item_title">
            纪念堂是否已认领：<span class="v_memorial_item_name">{{
              item.claimState == 1 ? "是" : "否"
            }}</span>
          </div>
          <div
            class="v_memorial_item_title"
            style="margin-bottom: 0rem; padding-bottom: 1.5rem"
          >
            Ta访问此纪念堂的次数：<span class="v_memorial_item_name">{{
              item.userViewCount
            }}</span>
          </div>
          <div class="v_memorial_bottom">
            <div class="v_update_button" @click="updateAll(item)">
              资料上传记录
            </div>
          </div>
        </div>
        <div class="v_have_no_line" v-if="visitDmList.length == 0"></div>
        <div class="v_have_no_line_white" v-if="visitDmList.length != 0"></div>
      </div>
      <div
        class="v_dialog_background"
        v-if="remarkDialog"
        @click.stop="cancleRemark()"
        @touchmove.prevent
      ></div>
      <div class="v_remark_bottom" v-if="remarkDialog" @touchmove.prevent>
        <div class="v_remark_bottom_top">
          <div class="v_remark_bottom_top_left">备注</div>
          <div class="v_remark_bottom_top_right" @click="cancleRemark()">
            取消
          </div>
        </div>
        <div class="edit_input_all">
          <el-input
            :placeholder="loginData.nick + '：'"
            v-model.trim="remarkText"
            maxlength="30"
            class="edit_input"
            clearable
          ></el-input>
          <div class="edit_input_button" @click="queryRemark()">确定</div>
        </div>
      </div>
      <!-- 逝者信息 -->
      <div
        class="v_dialog_background"
        v-if="showOtherInfos"
        @click.stop="cancleDeathInfo()"
        @touchmove.prevent
      ></div>
      <div class="v_remark_middle" @touchmove.prevent v-if="showOtherInfos">
        <div class="title">备注信息</div>
        <div class="cell_area">
          <div class="cell_line">
            <div class="cell_title" style="letter-spacing: 4px">逝者姓名</div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">{{ deadName }}</div>
          </div>
          <div class="cell_line">
            <div class="cell_title">
              <span style="float: left">生</span
              ><span style="float: right; margin-right: 10px">辰</span>
            </div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">
              {{ deadBirthday }}
            </div>
          </div>
          <div class="cell_line">
            <div class="cell_title">
              <span style="float: left">忌</span
              ><span style="float: right; margin-right: 10px">辰</span>
            </div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">
              {{ deadDeathay }}
            </div>
          </div>
          <div class="cell_line">
            <div class="cell_title">主办人姓名</div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">{{ hostName }}</div>
          </div>
          <div class="cell_line">
            <div class="cell_title">主办人手机</div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">{{ hostNameTel }}</div>
          </div>
          <div class="cell_line">
            <div class="cell_title">
              <span style="float: left">访</span>
              <span style="margin-left: 16px">问</span>
              <span style="float: right; margin-right: 5px">码</span>
            </div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">
              <img
                class="v_remark_wxcode"
                :src="wxAcodeUrl"
                @click="showWxAcodeUrl"
              />
            </div>
          </div>
        </div>

        <div class="line"></div>
        <div class="btn" @click.stop="cancleDeathInfo()">确定</div>
      </div>
    </div>
    <div v-if="haveData == 2" class="v_have_no_data">
      <img
        src="@/assets/images/personal/iv_no_data.png"
        alt=""
        class="iv_no_data"
      />
      <div class="v_no_data_text">您与此客户暂时不是好友</div>
      <div class="v_no_data_text" style="margin-top: 0.5rem">
        不可查看相关信息
      </div>
    </div>
    <div
      class="v_dialog_background"
      v-if="downDialog"
      @click.stop="cancleDown()"
      @touchmove.prevent
    ></div>
    <div
      class="v_down_code"
      v-if="downDialog"
      @touchmove.prevent
      @click.stop="cancleDown()"
    >
      <img :src="imgCode" alt="" class="iv_down_code" />
      <div class="v_down_code_button" @click.stop="downImg()">下载</div>
    </div>
    <el-dialog class="dialog-month-add" title="延长有效期" :visible.sync="monthDialog" width="80%" :show-close="false"
      :close-on-click-modal="false">
      <div style="display: flex;flex-direction: column;">
        <span>请选择延长几个月：</span>
        <el-select v-model="monthNum" placeholder="请选择">
          <el-option v-for="item in 12" :key="item" :label="item + '个月'" :value="item">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="monthDialog = false">取消</el-button>
        <el-button type="primary" @click="addCloseTime">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
import { updataLink, nowDate, PMSLIST } from "@/utils/utils";
import axios from "axios";
export default {
  data() {
    return {
      url: "",
      //b: "",
      //c: "",
      //d: "",
      userId: "",
      loadingAll: "",
      linkUrl: "",
      code: "",
      nickName: "",
      // 20230207 ->
      idForShow: "",
      loginMobileState: "",
      showOtherInfos: false,
      deadName: "",
      deadBirthday: "",
      deadDeathay: "",
      hostName: "",
      hostNameTel: "",
      wxAcodeUrl: "",
      // <- 20230227
      dmList: [],
      visitDmList: [],
      serviceAdminRemark: [],
      loginData: {},
      remarkText: "",
      remarkDialog: false,
      haveData: 0,
      pms: {
        downCode: false,
        renewCode: false,
      },
      isPc: false,
      imgCode: "",
      nameCode: "",
      downDialog: false,
      monthDialog: false,
      monthDmId: 0,
      monthNum: 1,
    };
  },
  created() {
    this.loadingAll = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    //本地调试
    //this.url = /api
    //this.userId = "wor8rTDwAAEalZHTpMGqT5SkyAGvRoNQ";
    //this.findByWxEnterpriseId();
    //return;
    if (
      window.navigator.userAgent.substring(13, 14) == "W" ||
      window.navigator.userAgent.substring(13, 14) == "M"
    ) {
      this.isPc = true;
    }
    let link = window.location.href;
    let linkk = window.location.href;
    let linkUrl = linkk.split("#/personaldetails");
    this.linkUrl = linkUrl[0];

    let links = link.split("code=");
    let linksA = links[1].split("&state=");
    this.code = linksA[0];
    let linksB = linksA[1].split("#/personaldetails");

    if (window.sessionStorage.getItem("login_data") != undefined) {
      this.loginData = JSON.parse(window.sessionStorage.getItem("login_data"));
      this.pms.downCode =
        window.sessionStorage.getItem("down_code") == "0" ? true : false;
      this.pms.renewCode =
        window.sessionStorage.getItem("renew_code") == "0" ? true : false;
      this.getWxEnterpriseAgentJSResDto();
    } else {
      this.getLoginWxEnterprise(linksB);
    }
  },

  computed: {},

  mounted() {},

  methods: {
    //SpringSecurity企微登录
    getLoginWxEnterprise(linksB) {
      let that = this;
      let postData = new FormData();
      postData.append("code", this.code);
      let testRequest = new Request(this.url + "/loginWxEnterprise", {
        method: "POST",
        body: postData,
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //this.b = JSON.stringify(res);
          if (res.status == 1000) {
            that.loginData = res.data;

            window.sessionStorage.setItem(
              "login_data",
              JSON.stringify(res.data)
            );

            let allPms = JSON.parse(JSON.stringify(PMSLIST));
            if (that.loginData.validateRole) {
              if (that.loginData.role != undefined) {
                that.loginData.role.menus.forEach((item) => {
                  let idStr = item.id.toString();
                  if (Object.keys(allPms).indexOf(idStr) >= 0) {
                    allPms[idStr].check = true;
                  }
                });
              }
            } else {
              Object.keys(allPms).forEach((item) => {
                if (allPms[item].adminPms) {
                  allPms[item].check = true;
                }
              });
            }

            that.pms.downCode = allPms["70500"].check;
            that.pms.renewCode = allPms["70600"].check;

            let downCode = allPms["70500"].check ? "0" : "1";

            let renewCode = allPms["70600"].check ? "0" : "1";

            window.sessionStorage.setItem("down_code", downCode);
            window.sessionStorage.setItem("renew_code", renewCode);

            that.getWxEnterpriseAgentJSResDto();
          } else if (res.status == 1004) {
            that.loadingAll.close();
            that.$message.error("当前登录账户已禁用");
          } else if (res.status == 1027) {
            that.loadingAll.close();
            that.$message.error("您的权限已发生变更，如有问题请联系中枢");
            this.getLoginWxEnterprise("");
          } else {
            that.loadingAll.close();
            that.$message.error("企微登录失败");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //获取企业微信JS授权信息
    // getWxEnterpriseJSResDto() {
    //   let testRequest = new Request(
    //     this.url + "/common/getWxEnterpriseJSResDto",
    //     {
    //       method: "POST",
    //       credentials: "include",
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8;",
    //       },
    //       body: JSON.stringify({
    //         data: {},
    //       }),
    //     }
    //   );
    //   fetch(testRequest)
    //     .then((response) => {
    //       return response.json();
    //     })
    //     .then((res) => {
    //       this.b = JSON.stringify(res);
    //       if (res.status == 1000) {
    //         this.toWx(res.data);
    //       } else {
    //       }
    //     })
    //     .catch(function (err) {
    //       console.log(err);
    //     });
    // },

    // toWx(data) {
    //   let that = this;
    //   wx.config({
    //     beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    //     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //     appId: data.appId, // 必填，企业微信的corpID
    //     timestamp: data.timestamp, // 必填，生成签名的时间戳
    //     nonceStr: data.nonceStr, // 必填，生成签名的随机串
    //     signature: data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
    //     jsApiList: ["openUserProfile", "getCurExternalContact"], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    //   });
    //   wx.ready(function () {
    //     // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    //     //that.loadingAll.close();
    //     that.toProfile();
    //   });
    //   wx.error(function (res) {
    //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    //     //that.loadingAll.close();
    //   });
    // },

    //获取企业微信应用JS授权信息
    getWxEnterpriseAgentJSResDto() {
      let that = this;
      let testRequest = new Request(
        this.url + "/common/getWxEnterpriseAgentJSResDto",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: this.linkUrl,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            that.toWxAgent(res.data);
          } else {
            that.loadingAll.close();
            that.$message.error("企业微信应用JS授权失败");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    toWxAgent(data) {
      let that = this;
      wx.agentConfig({
        corpid: data.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: [
          "openUserProfile",
          "getCurExternalContact",
          "downloadImage",
          "previewImage"
        ], //必填，传入需要使用的接口名称
        success: function (res) {
          // 回调
          that.getWXCurExternalContact();
        },
        fail: function (res) {
          that.loadingAll.close();
          if (res.errMsg.indexOf("function not exist") > -1) {
            alert("版本过低请升级");
            return;
          }
          that.$message.error("wx.agentConfig失败");
        },
      });
    },

    getWXCurExternalContact() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.err_msg == "getCurExternalContact:ok") {
          that.userId = res.userId; //返回当前外部联系人userId
          that.findByWxEnterpriseId();
        } else {
          //错误处理
          // res.err_msg;
          that.loadingAll.close();
          that.$message.error("getCurExternalContact失败");
        }
      });
    },

    //用户详情-企微
    findByWxEnterpriseId() {
      let that = this;
      let testRequest = new Request(
        this.url + "/bygUser/findByWxEnterpriseId",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: this.userId,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          that.loadingAll.close();
          //that.b = JSON.stringify(res);
          if (res.status == 1000) {
            that.haveData = 1;
            that.nickName = res.data.nickname;
            that.idForShow = res.data.id;
            that.loginMobileState = res.data.loginMobileState == 1 ? "是" : "否";
            //管理
            if (res.data.dmList != undefined && res.data.dmList.length > 0) {
              res.data.dmList.forEach((item) => {
                var arr = item.code.split("");
                var arrs = [];
                var str = "";
                while (arr.length > 0) {
                  var arrThis = arr.splice(0, 4);
                  var strThis = arrThis.join("");
                  arrs.push(strThis);
                }
                str = arrs.join(" ");
                item.codeNew = str;
                item.createTimeNew =
                  item.createTime.substring(0, 4) +
                  "/" +
                  item.createTime.substring(5, 7) +
                  "/" +
                  item.createTime.substring(8, 10);
                item.closeTimeNew =
                  item.closeTime.substring(0, 4) +
                  "/" +
                  item.closeTime.substring(5, 7) +
                  "/" +
                  item.closeTime.substring(8, 10);
                if (item.userState == 4) {
                  item.stateNew = "失效";
                } else {
                  if (item.foreverState == 1) {
                    item.stateNew = "永久";
                  } else {
                    if (item.status == 2) {
                      item.stateNew = "过期";
                    } else if (item.status == 1) {
                      if (item.closeTimeState == 1) {
                        item.stateNew = "即将过期";
                      } else {
                        item.stateNew = "有效";
                      }
                    }
                  }
                }
                if (item.spaceFrozen == 1) {
                  item.stateCold = "已冻结";
                }
                if (item.userState == 1) {
                  item.userStateName = "主办人";
                } else if (item.userState == 0) {
                  item.userStateName = "管理员";
                } else if (item.userState == 2) {
                  item.userStateName = "";
                } else if (item.userState == 3) {
                  item.userStateName = "";
                } else if (item.userState == 4) {
                  item.userStateName = "";
                }
                //纪念堂是否自动续期：1是，0否
                if(item.autoRenewState == 1){
                  item.autoRenewStateName = "是";
                }else if(item.autoRenewState == 0){
                  item.autoRenewStateName = "否";
                }
              });
              that.dmList = res.data.dmList;
            } else {
              that.dmList = [];
            }
            //拜访
            if (
              res.data.visitDmList != undefined &&
              res.data.visitDmList.length > 0
            ) {
              res.data.visitDmList.forEach((item) => {
                var arr = item.code.split("");
                var arrs = [];
                var str = "";
                while (arr.length > 0) {
                  var arrThis = arr.splice(0, 4);
                  var strThis = arrThis.join("");
                  arrs.push(strThis);
                }
                str = arrs.join(" ");
                item.codeNew = str;
                item.createTimeNew =
                  item.createTime.substring(0, 4) +
                  "/" +
                  item.createTime.substring(5, 7) +
                  "/" +
                  item.createTime.substring(8, 10);
                item.closeTimeNew =
                  item.closeTime.substring(0, 4) +
                  "/" +
                  item.closeTime.substring(5, 7) +
                  "/" +
                  item.closeTime.substring(8, 10);
                if (item.userState == 4) {
                  item.stateNew = "失效";
                } else {
                  if (item.foreverState == 1) {
                    item.stateNew = "永久";
                  } else {
                    if (item.status == 2) {
                      item.stateNew = "过期";
                    } else if (item.status == 1) {
                      if (item.closeTimeState == 1) {
                        item.stateNew = "即将过期";
                      } else {
                        item.stateNew = "有效";
                      }
                    }
                  }
                }
                if (item.spaceFrozen == 1) {
                  item.stateCold = "已冻结";
                }
              });
              that.visitDmList = res.data.visitDmList;
            } else {
              that.visitDmList = [];
            }
            if (
              res.data.serviceAdminRemark != undefined &&
              res.data.serviceAdminRemark.length > 0
            ) {
              that.serviceAdminRemark = res.data.serviceAdminRemark;
              // res.data.serviceAdminRemark.forEach((item) => {
              //   if (item.enterpriseNumber == that.loginData.enterpriseNumber) {
              //     that.remarkText = item.remark;
              //   }
              // });
            } else {
              that.serviceAdminRemark = [];
            }
          } else if (res.status == 1076) {
            //数据不存在
            that.haveData = 2;
          } else {
            that.$message.error("获取用户详情失败");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //获取购买纪念堂二维码
    downCreateOR() {

      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      let testRequest = new Request(this.url + "/bygOrder/getPurchaseQRCode", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json;charset=UTF-8;",
        },
        body: {},
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          that.loadingAll.close();
          if (res.status == 1000) {
            if (that.isPc) {
              that.downDialog = true;
              that.imgCode = res.data;
              that.nameCode = "a";
            } else {
              wx.previewImage({
                current: res.data, // 第一张显示的图片链接
                urls: [res.data], // 需要预加载的图片http链接列表，预加载后，可以滑动浏览这些图片
              });
            }
          } else {
            that.$message.error("新建二维码失败");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //创建续费纪念堂二维码
    createdRenew(code, name) {
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      let params = {
        code: code,
        productId: "2",
      };
      let testRequest = new Request(this.url + "/bygOrder/getRenewQRCode", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json;charset=UTF-8;",
        },
        body: JSON.stringify({
          data: params,
        }),
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          that.loadingAll.close();
          //that.d = JSON.stringify(res);
          if (res.status == 1000) {
            if (this.isPc) {
              that.downDialog = true;
              that.imgCode = res.data.qrcodeUrl;
              that.nameCode = name;
            } else {
              wx.previewImage({
                current: res.data.qrcodeUrl, // 第一张显示的图片链接
                urls: [res.data.qrcodeUrl], // 需要预加载的图片http链接列表，预加载后，可以滑动浏览这些图片
              });
            }
          } else if (res.status == 1076) {
            that.$message.error("该纪念堂已失效，不可下载二维码");
          } else {
            that.$message.error("创建续费二维码失败");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    updateAll(v) {
      this.$router.push({
        path: "/updaterecord",
        query: {
          id: v.id,
        },
      });
    },

    cancleDown() {
      this.downDialog = false;
      this.imgCode = "";
      this.nameCode = "";
    },

    downImg() {
      let routeData = this.$router.resolve({
        path: "/wxspacedetails",
        query: {
          img: this.imgCode,
          name: this.nameCode,
        },
      });
      window.open(routeData.href, "_blank");
    },

    // toProfile() {
    //   let that = this;
    //   wx.invoke(
    //     "openUserProfile",
    //     {
    //       type: 2, //1表示该userid是企业成员，2表示该userid是外部联系人
    //       userid: that.userId, //可以是企业成员，也可以是外部联系人
    //     },
    //     function (res) {
    //       if (res.err_msg != "openUserProfile:ok") {
    //         //错误处理
    //       }
    //     }
    //   );
    // },

    toRemark() {
      if (this.serviceAdminRemark.length > 0) {
        this.serviceAdminRemark.forEach((item) => {
          if (item.enterpriseNumber == this.loginData.enterpriseNumber) {
            this.remarkText = item.remark;
          }
        });
      }
      this.remarkDialog = true;
    },

    cancleRemark() {
      this.remarkDialog = false;
      this.remarkText = "";
    },

    // 逝者信息dialog
    cancleDeathInfo() {
      this.showOtherInfos = false;
      this.deadName = "";
      this.deadBirthday = "";
      this.deadDeathay = "";
      this.hostName = "";
      this.hostNameTel = "";
      this.wxAcodeUrl = "";
    },
    showDeadInfoDialog(list, index) {
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var objThis = list[index];
      this.showOtherInfos = true;
      this.deadName = objThis.remarkName ? objThis.remarkName : "";
      this.deadBirthday = objThis.remarkBirthday ? objThis.remarkBirthday : "";
      this.deadDeathay = objThis.remarkDeadday ? objThis.remarkDeadday : "";
      this.hostName = objThis.undertakerName ? objThis.undertakerName : "";
      let that = this;
      let testRequest = new Request(this.url + "/bygDeadManV2/findWxEnterpriseRemarkById", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json;charset=UTF-8;",
        },
        body: JSON.stringify({
          data: objThis.id,
        }),
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            that.wxAcodeUrl = res.data.wxAcodeUrl;
            that.hostNameTel = res.data.undertakerTel;
          }else{
            that.$message.error("获取信息失败，请检查网络连接");
          }
          that.loadingAll.close();
        })
        .catch(function (err) {
          console.log(err);
          that.$message.error("获取信息失败，请检查网络连接");
          that.loadingAll.close();
        });
      
    },
    showWxAcodeUrl(img) {
      if (img.target.classList.contains("v_remark_wxcode_zoomed")) {
        // 如果已放大，移除zoomed类以恢复原始大小
        img.target.classList.remove("v_remark_wxcode_zoomed");
      } else {
        // 如果未放大，添加zoomed类以放大图片
        img.target.classList.add("v_remark_wxcode_zoomed");
      }
    },
    cancle() {},

    queryRemark() {
      let that = this;
      // if (that.remarkText.length == 0) {
      //   return;
      // }
      let data = {
        openid: that.userId,
        enterpriseNumber: that.loginData.enterpriseNumber,
        remark: that.remarkText,
      };
      let testRequest = new Request(
        that.url + "/bygUser/updateWxEnterpriseRemark",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: data,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //that.d = JSON.stringify(res);
          if (res.status == 1000) {
            let isHave = false;
            if (that.serviceAdminRemark.length > 0) {
              if (that.remarkText != "") {
                that.serviceAdminRemark.forEach((item) => {
                  if (
                    item.enterpriseNumber == that.loginData.enterpriseNumber
                  ) {
                    isHave = true;
                    item.remark = that.remarkText;
                  }
                });
                if (!isHave) {
                  let item = {};
                  item.enterpriseNumber = that.loginData.enterpriseNumber;
                  item.remark = that.remarkText;
                  item.nick = that.loginData.nick;
                  that.serviceAdminRemark.unshift(item);
                }
              } else {
                for (var i = that.serviceAdminRemark.length - 1; i >= 0; i--) {
                  if (
                    that.serviceAdminRemark[i].enterpriseNumber ==
                    that.loginData.enterpriseNumber
                  ) {
                    that.serviceAdminRemark.splice(i, 1);
                  }
                }
              }
            } else {
              if (that.remarkText != "") {
                let item = {};
                item.enterpriseNumber = that.loginData.enterpriseNumber;
                item.remark = that.remarkText;
                item.nick = that.loginData.nick;
                that.serviceAdminRemark.push(item);
              }
            }
            that.remarkDialog = false;
          } else {
            that.$message.error("备注失败");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //复制
    copy(code) {
      var domUrl = document.createElement("input");
      domUrl.value = code;
      domUrl.id = "creatDom";
      document.body.appendChild(domUrl);
      domUrl.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      let creatDom = document.getElementById("creatDom");
      creatDom.parentNode.removeChild(creatDom);
      this.$message.success("操作成功");
    },

    //到期日增加-企微
    addCloseTime(dmId) {
      if (!this.monthDialog) {
        this.monthDialog = true;
        this.monthDmId = dmId;
        return;
      }
      let that = this;
      let testRequest = new Request(
        this.url + "/bygDeadManV2/addCloseTime",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: {
              dmId: this.monthDmId,
              monthNum: this.monthNum,
            },
          }),
        }
      );
      fetch(testRequest).then((response) => {
        return response.json();
      }).then((res) => {
        //that.c = JSON.stringify(res);
        if (res.status == 1000) {
          that.$message.success("操作成功");
          that.monthDialog = false;
          that.findByWxEnterpriseId();
        } else {
          that.$message.error("获取信息失败，请检查网络连接");
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.v_all_all {
  background-color: #F7F8F9;
}

.v_all_background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #F7F8F9;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v_have_no_data {
  position: fixed;
  left: 0;
  right: 0;
  top: 10px;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  // justify-content: center;
  .iv_no_data {
    margin-top: 20vh;
    width: 125px;
    height: 125px;
    margin-bottom: 50px;
  }

  .v_no_data_text {
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }
}

.v_top_line {
  width: 100%;
  height: 10px;
}

.v_top_person {
  background-color: #ffffff;

  .v_top_person_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    line-height: 60px;
    padding-top: 2px;
    box-sizing: border-box;
  }

  .v_top_person_title_left {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    margin-left: 18px;
  }

  .v_top_person_title_right {
    font-size: 16px;
    font-weight: 400;
    color: #F19100;
    margin-right: 18px;
    cursor: pointer;
  }

  .v_top_person_name {
    margin-left: 18px;
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    height: 60px;
    line-height: 60px;
    word-wrap: break-word;
    word-break: break-all;
    padding-top: 2px;
    box-sizing: border-box;
  }

  .v_top_person_nick {
    font-size: 16px;
    font-weight: 400;
    color: #949494;
  }

  .v_top_person_remark {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 18px;
    font-size: 16px;
    font-weight: 400;
    color: #949494;
  }

  .v_top_person_remark_list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: auto;
    margin-left: 18px;
    margin-right: 8px;
  }

  .v_remark_item {
    background: #F7F7F7;
    border-radius: 7px;
    border: 1px solid #D5D5D5;
    font-size: 13px;
    font-weight: 400;
    color: #000000;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 2px;
    line-height: 20px;
    margin-right: 10px;
    margin-bottom: 10px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .v_top_person_bottom {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 20px;
    padding-top: 10px;
  }

  .v_top_person_button {
    width: 150px;
    height: 30px;
    line-height: 30px;
    background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
    box-shadow: 0px 8px 20px 2px #FFDDC3;
    border-radius: 45px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }
}

.v_line {
  background: #D5D5D5;
  height: 1px;
  width: 100%;
}

.v_line_small {
  margin-left: 18px;
  margin-right: 18px;
  width: auto;
  height: 1px;
  background: #D5D5D5;
}

.v_memorial_all {
  margin-top: 10px;
  background-color: #ffffff;

  .v_memorial_title {
    margin-left: 18px;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .v_memorial_number {
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
    margin-left: -5px;
  }

  .v_memorial_item {
    margin-top: 15px;
    margin-left: 18px;
    margin-right: 18px;
    background: #F7F8F9;
    padding-top: 15px;
  }

  .v_memorial_item_title {
    margin-left: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #949494;
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
  }

  .v_copy {
    width: 40px;
    height: 20px;
    background: #FFFAEE;
    border-radius: 4px;
    border: 1px solid #FF9B5D;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #FF9B5D;
    margin-left: 5px;
    cursor: pointer;
  }

  .v_memorial_item_left {
    flex-shrink: 0;
  }

  .v_memorial_item_name {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    // margin-right: 10px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .v_memorial_item_name_red {
    font-size: 16px;
    font-weight: 400;
    color: #EC2F2F;
    // color: #000000;
    margin-right: 10px;
    // margin-left: 10px;
  }

  .v_memorial_bottom {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .v_create_button {
    width: 135px;
    height: 30px;
    background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
    box-shadow: 0px 8px 20px 1px #FFDDC3;
    border-radius: 22px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: 19px;
    // margin-top: 4px;
    cursor: pointer;
  }

  .v_update_button {
    width: 135px;
    height: 30px;
    background: #ffffff;
    border: 1px solid #FF9B5D;
    border-radius: 22px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #FF9B5D;
    margin-bottom: 19px;
    cursor: pointer;
    margin-right: 15px;
  }

  .v_create_button_no {
    width: 150px;
    height: 30px;
    background: linear-gradient(90deg, #959595 0%, #AEAEAE 100%);
    box-shadow: 0px 8px 20px 1px #E9E9E9;
    border-radius: 22px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: 19px;
    // margin-top: 4px;
  }

  .v_memorial_bottom_line {
    width: 100%;
    height: 15px;
  }
}

.v_have_no_text_no {
  font-size: 15px;
  font-weight: 400;
  color: #949494;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  margin-bottom: 5px;
}

.v_have_no_line {
  height: 15px;
  width: 100%;
  background-color: #F7F8F9;
}

.v_have_no_line_white {
  height: 15px;
  width: 100%;
  background-color: #ffffff;
}

.v_have_no {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  // height: 206px;
  .iv_have_no {
    margin-top: 20px;
    width: 60px;
    height: 60px;
  }

  .v_have_no_text {
    margin-top: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }
}

.v_remark_bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 350px;
  background: #FFFFFF;
  width: 100%;
  box-shadow: 0px -2px 5px 2px rgba(123, 123, 123, 0.2);
  border-radius: 15px 15px 0px 0px;

  .v_remark_bottom_top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;
  }

  .v_remark_bottom_top_left {
    font-size: 22px;
    font-weight: 500;
    color: #000000;
    margin-left: 25px;
  }

  .v_remark_bottom_top_right {
    font-size: 17px;
    font-weight: 400;
    color: #F19100;
    margin-right: 25px;
  }
}

.v_remark_middle {
  position: fixed;
  left: 22px;
  right: 22px;
  top: 100px;
  border-radius: 15px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    width: 100%;
    height: 32px;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    line-height: 32px;
    text-align: center;
    padding: 30px 0 5px;
  }

  .cell_area {
    padding: 0 15px;
    display: inline-block;

    .cell_line {
      font-size: 16px;
      line-height: 22px;
      display: flex;
      flex-direction: row;
      margin-top: 15px;

      .cell_title {
        width: 84px;
        color: #949494;
        flex-shrink: 0;
      }

      .cell_content {
        min-width: 100px;
        word-break: break-all;
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #D8D8D8;
    margin-top: 40px;
  }

  .btn {
    width: 100%;
    height: 68px;
    font-size: 20px;
    font-weight: 500;
    color: #EF9400;
    line-height: 68px;
    text-align: center;
  }
}

.edit_input_all {
  margin-top: 50px;
  margin-left: 25px;
  margin-right: 25px;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .edit_input >>>.el-input__inner {
    border-radius: 5px;
    border: 1px solid #979797;
    padding-top: 1px;
  }

  .edit_input_button {
    margin-top: 100px;
    width: 220px;
    height: 50px;
    background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
    box-shadow: 0px 8px 20px 1px #FFDDC3;
    border-radius: 25px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
  }
}

.v_dialog_background {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: #000000;
  opacity: 0.7;
}

.v_down_code {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;   /* Non-prefixed version, currently
  not supported by any browser */

  .iv_down_code {
    width: 300px;
    height: 300px;
  }

  .v_down_code_button {
    margin-top: 20px;
    width: 120px;
    height: 30px;
    line-height: 30px;
    background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    text-shadow: 0px 1px 1px #CE621E;
    text-align: center;
    cursor: pointer;
  }
}

.v_remark_wxcode {
  width: 40px;
  height: 40px;
}

.v_remark_wxcode_zoomed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: none;
  background-color: rgba(0, 0, 0, 0.5);
}

.dialog-month-add >>> .el-dialog__body{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PersonalDetails/PersonalDetails.vue